<template>
  <fieldset v-if="getMetaDataConfig({ infoRequiredName }).loaded">
    <legend>
      <XVhelpcontrol :helptext="legendHelpText" v-if="legendHelpText"></XVhelpcontrol>
      <span>{{ legendText }}</span>
      <a name="meta">&nbsp;</a>
    </legend>
    <div class="fieldsettable">
      <div>
        <XVbootstraprow
          v-for="(metaDataRequired, index) in metaData[infoRequiredName]"
          :key="metaDataRequired.metaveldtableID + '_index' + index"
          :label="metaDataRequired.metaveldLabel"
          :helptext="metaDataRequired.metaveldHelptext"
          :haserror="haserrors(metaDataRequired)"
          :errormessage="errors.first(veldnaam(metaDataRequired))"
          :required="metaDataRequired.metaveldModifyType === 3"
          :headerText="metaDataRequired.headerText"
          :veldID="veldnaam(metaDataRequired)"
        >
          <template v-if="metaDataRequired.metaveldModifyType === 2 || metaDataRequired.metaveldModifyType === 3">
            <component
              v-bind:is="useComponent(metaDataRequired)"
              :id="veldnaam(metaDataRequired)"
              v-validate="validationSchema(metaDataRequired)"
              v-model="metaDataRequired.metaveldValue"
              :type="type(metaDataRequired)"
              :name="veldnaam(metaDataRequired)"
              :haserror="errors.has(veldnaam(metaDataRequired))"
              :datalist="metaDataRequired.possibleValues"
              :data-vv-as="metaDataRequired.metaveldLabel"
              :labelAlignTop="true"
              :headersVisible="metaDataRequired.metaveldHeaderVisible === 1 ? true : false"
              :formatter="formatter(metaDataRequired)"
              :maximumfilecount="metaDataRequired.metaveldAmountFiles"
              :hideSelected="true"
              :formdata="{
                  onlyHeader: false,
                  tblQuestionShowHeader: metaDataRequired.metaveldHeaderVisible
                }"
            />
          </template>
          <template v-if="metaDataRequired.metaveldModifyType === 1 && metaDataRequired.metaveldFieldTypeID === 6">
            <span class="selectTag" v-for="(metaval, index) in formatValue(metaDataRequired)" :key="index">
              {{ metaval.labelText }}
            </span>
          </template>
          <template
            v-else-if="
              metaDataRequired.metaveldModifyType === 1 &&
              (metaDataRequired.metaveldFieldTypeID === 10 ||
                metaDataRequired.metaveldFieldTypeID === 11 ||
                metaDataRequired.metaveldFieldTypeID === 9)
            "
          >
            <component
              :id="veldnaam(metaDataRequired)"
              :key="index"
              v-bind:is="useComponent(metaDataRequired)"
              :disabled="true"
              :datalist="metaDataRequired.possibleValues"
              v-model="metaDataRequired.metaveldValue"
              :data-vv-validate-on="useEvent(metaDataRequired)"
            ></component>
          </template>
          <template
            v-else-if="metaDataRequired.metaveldModifyType === 1 && metaDataRequired.metaveldFieldTypeID === 12"
          >
            <a
              v-for="(metaval, index) in formatValue(metaDataRequired)"
              :key="index"
              class="link"
              :href="metaval.url"
              target="_blank"
              >{{ metaval.labelText }}</a
            >
          </template>
          <template v-else-if="metaDataRequired.metaveldModifyType === 1 && metaDataRequired.metaveldFieldTypeID === 8">
            <a v-for="(metaval, index) in formatValue(metaDataRequired)" :key="index" class="link" :href="metaval.url">
              {{ metaval.labelText }}
            </a>
          </template>
          <template v-else-if="metaDataRequired.metaveldModifyType === 1">
            <span v-for="(metaval, index) in formatValue(metaDataRequired)" :key="index">{{ metaval.labelText }}</span>
          </template>
        </XVbootstraprow>
      </div>
    </div>
  </fieldset>
</template>
<script>
import XVupload from '@/components/XVupload'
import { util } from 'pevueglobal'
import { sync, call } from 'vuex-pathify'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...sync('Metafields/*'),
    ...mapGetters('Metafields', ['getMetaDataConfig']),
  },
  inject: ['$validator'], // dit doe ik om de validators te triggeren van de dynamische input, zodat bij validatie hoofdniveau de onderliggende ook afgaan

  components: {
    XVupload,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    infoRequiredName: {
      // configuratie naam, zie infoRequiredName enum in webapi
      type: String,
      required: true,
    },
    parameters: {
      type: Array,
      default: function () {
        return []
      },
    },
    postData: {
      type: Object,
      default: function () {
        return {}
      },
    },
    legendText: {
      type: String,
    },
    legendHelpText: {
      type: String,
    },
  },
  data: function () {
    return {}
  },
  async mounted() {
    await this.getMetaData({ infoRequiredName: this.infoRequiredName, parameters: this.parameters, ...this.postData }) // haal data op voor meta
  },
  methods: {
    getMetaData: call('Metafields/getMetaData'),
    formatter(metaDataRequired) {
      // formatter returned een functie met args value en event, de functie zelf returned de nieuwe value
      // event geeft aan of dit input of blur event is, bij url wil je namelijk alleen met blur de formatter erop loslaten

      // bij een url moet als er geen http voor staat http voor de waarde gezet worden
      if (metaDataRequired.metaveldFieldTypeID === 12) {
        return (value, event) => {
          if (event === 'blur' && value !== '') {
            if (value.indexOf('http://') !== 0 && value.indexOf('https://') !== 0 && value.indexOf('://') !== 0) {
              return (value = 'http://' + value)
            } else {
              return value
            }
          } else {
            return value
          }
        }
      }
      // bij een decimal moet de . in een komma worden gewijzigd
      if (metaDataRequired.metaveldFieldTypeID === 3) {
        return (value, event) => {
          return value.replace('.', ',').replace(' ', '')
        }
      }

      // bij een emailadres spaties omzetten in ;
      if (metaDataRequired.metaveldFieldTypeID === 8) {
        return (value, event) => {
          return value.replace(' ', ';').replace(';;', ';')
        }
      }

      return undefined
    },
    useComponent(compData) {
      // bepaal vue component a.h.v. id in DB
      if (compData.metaveldFieldTypeID === 1) {
        return 'XVdate'
      } else if (compData.metaveldFieldTypeID === 2) {
        return 'XVdate'
      } else if (compData.metaveldFieldTypeID === 7) {
        return 'XVtextarea'
      } else if (compData.metaveldFieldTypeID === 5) {
        return 'XVdropdown'
      } else if (compData.metaveldFieldTypeID === 6) {
        return 'XVmultiselect'
      } else if (compData.metaveldFieldTypeID === 9) {
        return 'XVupload'
      } else if (compData.metaveldFieldTypeID === 10 && compData.metaveldHorizontaal === 0) {
        return 'XVcheckboxlist'
      } else if (compData.metaveldFieldTypeID === 10 && compData.metaveldHorizontaal === 1) {
        return 'XVcheckboxlistHorizontal'
      } else if (compData.metaveldFieldTypeID === 11 && compData.metaveldHorizontaal === 0) {
        return 'XVradiobuttonlist'
      } else if (compData.metaveldFieldTypeID === 11 && compData.metaveldHorizontaal === 1) {
        return 'XVradiobuttonlistHorizontal'
      } else {
        return 'XVinput'
      }
    },
    useEvent(compData) {
      // bepaal vue component a.h.v. id in DB
      if (compData.metaveldFieldTypeID === 1) {
        return 'formvaluechanged'
      } else if (compData.metaveldFieldTypeID === 2) {
        return 'formvaluechanged'
      } else if (compData.metaveldFieldTypeID === 7) {
        return 'formvaluechanged'
      } else if (compData.metaveldFieldTypeID === 5) {
        return 'formvaluechanged'
      } else if (compData.metaveldFieldTypeID === 6) {
        return 'formvaluechanged'
      } else if (compData.metaveldFieldTypeID === 9) {
        return 'change'
      } else if (compData.metaveldFieldTypeID === 10 && compData.metaveldHorizontaal === 0) {
        return 'formvaluechanged'
      } else if (compData.metaveldFieldTypeID === 10 && compData.metaveldHorizontaal === 1) {
        return 'formvaluechanged'
      } else if (compData.metaveldFieldTypeID === 11) {
        return 'formvaluechanged'
      } else {
        return 'formvaluechanged'
      }
    },
    haserrors(metaDataRequired) {
      // bepaal of er een error moet worden weergegeven
      if (this.fieldBags !== undefined){
        if (this.fieldBags[this.veldnaam(metaDataRequired)]) {
          return !this.fieldBags[this.veldnaam(metaDataRequired)].pending && this.errors.has(this.veldnaam(metaDataRequired))
        } else {
          return this.errors.has(this.veldnaam(metaDataRequired))
        }
      }
    },
    veldnaam(metaDataRequired) {
      // veldnaam

      return 'metafield' + metaDataRequired.metaveldtableID
    },
    type(metaDataRequired) {
      // subtypes voor normaal text veld
      if (metaDataRequired.metaveldFieldTypeID === 8) {
        return 'text' // dit is email, maar kan geen email type worden omdat er meerdere emailadressen in kunnen staan
      }
      if (metaDataRequired.metaveldFieldTypeID === 1) {
        return 'text'
      }
      if (metaDataRequired.metaveldFieldTypeID === 3) {
        return 'text' // dit ook een text gemaakt, decimal en type number gaan niet samen
      }
      if (metaDataRequired.metaveldFieldTypeID === 12) {
        return 'url'
      }
      return 'text'
    },
    validationSchema(metaDataRequired) {
      // dynamisch validatie schema voor de verschillende meta
      let schema = {}
      if (metaDataRequired.metaveldModifyType === 3) {
        schema.required = true
      }

      if (metaDataRequired.metaveldModifyType === 3 || metaDataRequired.metaveldModifyType === 2) {
        if (metaDataRequired.metaveldFieldTypeID === 8) {
          schema.XVMultipleEmail = true
        }
        if (metaDataRequired.metaveldFieldTypeID === 1) {
          schema.date_format = PEGLOBALS.Xdateformat
        }
        if (metaDataRequired.metaveldFieldTypeID === 3) {
          if (metaDataRequired.metaveldAantalDecimalen === 0) {
            schema.numeric = true
          } else {
            schema.XVdecimal = { decimalCount: metaDataRequired.metaveldAantalDecimalen }
          }
        }
        if (metaDataRequired.metaveldFieldTypeID === 12) {
          schema.url = true
        }
        if (metaDataRequired.tblDynamicDataRetrieveDefinitionIDCustomvalidator !== null) {
          // server validator

          // verzamel alle gegevens die meegestuurd dienen te worden
          let metafields = this.metaData[this.infoRequiredName]
          let fieldValues = []
          metafields.forEach((f) => {
            let fieldvalue = f.metaveldValue
            let valueToSend = ''

            if (Array.isArray(fieldvalue)) {
              fieldvalue.forEach((v) => {
                valueToSend = valueToSend + v + ','
              })
              valueToSend = valueToSend.substring(0, valueToSend.length - 1)
            } else {
              valueToSend = fieldvalue
            }
            fieldValues.push({
              key: 'field' + f.metaveldtableID,
              value: valueToSend,
              datevalue: null,
              intvalue: null,
              decimalvalue: null,
            })
          })
          // vul alle data en maak het server validatie schema aan
          // de functie die door dit schema word uitgevoerd staat in modules\customvalidators\servervalidators.js
          schema.serverValidate = {
            rowID: metaDataRequired.metaveldtableID,
            tblDynamicDataRetrieveDefinitionIDCustomvalidator:
              metaDataRequired.tblDynamicDataRetrieveDefinitionIDCustomvalidator,
            tblname: this.getMetaDataConfig({
              infoRequiredName: this.infoRequiredName,
            }).infoRequiredTableName,
            fieldValues,
          }
        }
      }

      return schema
    },
    formatValue(metaDataRequired) {
      // maak de value die het component verwacht voor de verschillende meta types
      if (metaDataRequired.metaveldValue === null || metaDataRequired.metaveldValue === '') {
        return undefined
      } else {
        if (metaDataRequired.metaveldFieldTypeID === 1 || metaDataRequired.metaveldFieldTypeID === 2) {
          return [{ labelText: util.jsDateToStringDate(new Date(metaDataRequired.metaveldValue)) }]
        } else if (metaDataRequired.metaveldFieldTypeID === 5 || metaDataRequired.metaveldFieldTypeID === 11) {
          return metaDataRequired.possibleValues.filter((p) => {
            return p.value === metaDataRequired.metaveldValue[0]
          })
        } else if (metaDataRequired.metaveldFieldTypeID === 6 || metaDataRequired.metaveldFieldTypeID === 10) {
          return metaDataRequired.possibleValues.filter((p) => {
            return metaDataRequired.metaveldValue.indexOf(p.value) !== -1
          })
        } else if (metaDataRequired.metaveldFieldTypeID === 12) {
          let url = ''
          if (
            metaDataRequired.metaveldValue.indexOf('http://') === -1 &&
            metaDataRequired.metaveldValue.indexOf('http://') === -1
          ) {
            url = '//' + metaDataRequired.metaveldValue
          } else {
            url = metaDataRequired.metaveldValue
          }
          return [{ url: url, labelText: metaDataRequired.metaveldValue }]
        } else if (metaDataRequired.metaveldFieldTypeID === 8) {
          let url = ''
          if (metaDataRequired.metaveldValue.indexOf('mailto:') === -1) {
            url = 'mailto:' + metaDataRequired.metaveldValue
          } else {
            url = metaDataRequired.metaveldValue
          }
          return [{ url: url, labelText: metaDataRequired.metaveldValue }]
        } else {
          return [{ labelText: metaDataRequired.metaveldValue }]
        }
      }
    },
  },
}
</script>
<style>
.selectTag {
  position: relative;
  display: inline-block;
  padding: 4px;
  border-radius: 2px;
  padding-left: 21px;
  padding-right: 21px;
  margin-right: 3px;
  margin-bottom: 0;
  background: #ccc;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  color: #555;
}
legend .graphQuestion {
  margin-bottom: 1px;
}
</style>
